import classNames from 'classnames/bind';
import styles from './EbookActivityDetails.module.css';
import { BAR_CHART_CONFIG } from '../../../constants/config';
import { getTopLevels } from '../../../utils/util';

const cx = classNames.bind(styles);

interface BarChartProps {
  data: { title: string; value: number }[];
}

export default function BarChart({ data }: BarChartProps) {
  const hourlyData = data.map((item) => ({
    ...item,
    value: Math.ceil(item.value / 3600),
  }));
  const values = hourlyData.map((item) => item.value);
  const levels = getTopLevels(values);
  const maxVal = Math.max(...values);

  let yMax = BAR_CHART_CONFIG.DEFAULT.yMax;
  let yStep = BAR_CHART_CONFIG.DEFAULT.yStep;

  for (const threshold of BAR_CHART_CONFIG.THRESHOLDS) {
    if (maxVal > threshold.maxVal) {
      yMax = threshold.yMax;
      yStep = threshold.yStep;
      break;
    }
  }

  const yLabels = [];
  for (let i = yMax; i >= 0; i -= yStep) {
    yLabels.push(i);
  }

  const getColorClass = (value: number) => {
    if (value === 0) return 'inactive';
    if (levels.highest.includes(value)) return 'active-pink';
    if (levels.second.includes(value)) return 'active-blue';
    return 'inactive';
  };

  return (
    <>
      <div className={cx('chart_y_labels')}>
        {yLabels.map((label) => (
          <div key={label} className={cx('y_label')}>
            {label}
          </div>
        ))}
      </div>
      <div className={cx('chart_area')}>
        <div className={cx('chart_grid')}>
          {Array.from(
            { length: BAR_CHART_CONFIG.GRID_LINE_COUNT },
            (_, i) => (
              <div key={i} className={cx('grid_line')}></div>
            )
          )}
        </div>
        <div
          className={cx('chart_bars')}
          style={{ '--chart-max-value': yMax } as React.CSSProperties}
        >
          {hourlyData.map((item, index) => (
            <div
              key={index}
              className={cx('chart_bar')}
              data-color={getColorClass(item.value)}
              style={
                {
                  '--bar-value': Math.min(item.value, yMax),
                } as React.CSSProperties
              }
            >
              <div className={cx('bar_fill')}></div>
            </div>
          ))}
        </div>
      </div>
      <div className={cx('chart_x_labels')}>
        {data.map((item, index) => (
          <div key={index} className={cx('x_label')}>
            {item.title}
          </div>
        ))}
      </div>
    </>
  );
}
